//@flow
import React from 'react';
import classNames from 'classnames';
import './styles.scss';

type Props = {
  data: {
    id: string,
    name: string,
  },
  selectedId: string,
  onClick: () => void,
};
export const TabView = (props: Props) => {
  const { data, selectedId, onClick } = props;
  const listClassName = classNames('tab-list', {
    'active-item': data.id === selectedId,
  });
  return (
    <li className={listClassName}>
      <a onClick={e => onClick(data.id)}>
        <h3>{data.name}</h3>
      </a>
    </li>
  );
};
